import {
  STATUS,
  User,
  applicationStatusHistory,
  certificationDetails,
  editChangesData,
  editHistoryData,
} from "@/models/common-interface/common.interface";
import { ReviewerPartTwoPageInterface } from "@/models/reviewer-part-two-page/reviewer-part-two-page.interface";
import { certificationFormApi } from "@/providers/apis/certification-part-two-form";
import { commonService } from "@/providers/services/common-service";
import { utils } from "@/utils/utils";
import moment from "moment";
import { Component, Prop, Vue } from "vue-property-decorator";
import AppLoaderComponent from "../app-loader/app-loader.component.vue";
import CertificationPartTwoPreviewForm from "../certification-part-two-preview-form/certification-part-two-preview-form.component.vue";
import EmploymentSummariesPreviewComponent from "../employment-summaries-preview/employment-summaries-preview.component.vue";
import LetterOfReferencePreviewComponent from "../letter-of-reference-preview-form/letter-of-reference-preview-form.component.vue";
import ScoreRubicFormComponent from "../score-rubic-form/score-rubic-form.component.vue";
import PDFViewerComponent from "../pdf-viewer/pdf-viewer.component.vue";
import FileUploadComponent from "../file-upload/file-upload.component.vue";
import { appConfigService } from "@/providers/services/app/app-config";
import PreviewPopupComponent from "../preview-popup/preview-popup.component.vue";
import ErrorPopupComponent from "../error-popup/error-popup.component.vue";

@Component({
  name: "reviewer-certification-part-two-preview-form",
  components: {
    AppLoaderComponent,
    CertificationPartTwoPreviewForm,
    ScoreRubicFormComponent,
    EmploymentSummariesPreviewComponent,
    LetterOfReferencePreviewComponent,
    PDFViewerComponent,
    FileUploadComponent,
    PreviewPopupComponent,
    ErrorPopupComponent,
  },
})
export default class ReviewerCertificationPartTwoPreviewForm extends Vue {
  @Prop()
  public applicationPreviewForm!: any;

  @Prop()
  public isPeerPreview!: any;
  public activeReferral: any = [];
  public activeSupervisor: any = [];
  public certificateApplicationId = "";
  public certificatePreviewForm: ReviewerPartTwoPageInterface =
    {} as ReviewerPartTwoPageInterface;
  public isLoading = true;
  public refrenceActiveIndex = 0;
  public supervisorActiveIndex = 0;
  public isMobileView = false;
  public tabSelected = "application-form";
  public applicationsTabSelect = "partTwo-basic-details";
  public formsSelect = "application-form";
  public headerHeight = 0;
  public sectionTabHeight = 0;
  public mobileSectionTabHeight = 0;
  public historys: applicationStatusHistory[] = [];
  public toogleStatus = false;
  public approveStatus = "";
  public applicantFullName = "";
  public approveComment = "";
  public userDetails!: User;
  public commentEventNone = false;
  public mostLastRecord: any = null;
  public isAllApplicationSubmitted = false;
  public isEditReviewer = false;
  public isApproveStatus = true;
  public isSubmit = false;
  public referenceIndex = 0;
  public supervisorIndex = 0;
  public showCommentBox = false;
  public showCommentBoxWithDisable = false;
  public showRubricTab = false;
  public isReferenceData = false;
  public isSupervisorData = false;
  public formType = "";
  public PDFApplicationPrintName = "";
  public source = "";
  public isUpdatePageNumber = false;
  public editedUserDetails: editHistoryData[] = [];
  public tooglebutton = false;
  public collapseIdx = "";
  public filesEdit: string[] = [];
  public isFormValid = false;
  public validForm = true;
  public refereshReference: any;
  public refereshSupervisor: any;
  public refereshReferenceAndSupervisor: any;
  public isUserApplication = false;
  public isMigrationForm = false;
  public certification = {
    certificateNumber: "",
    certificateFile: [] as any[],
  };
  public checkCertificateValid = false;
  public checkFileValidation = false;
  public showCertification = false;
  public isEditCertificate = false;
  public isCertificateSaving = false;
  public totalRejectedReferenceCount = 0;
  public totalRejectedSupervisorCount = 0;
  public isInformedApplicant = false;
  public applicationReceivedDate = "";
  public envType = "";
  public newlyRejectedReference: any[] = [];
  public newlyRejectedSupervisor: any[] = [];
  public tabScrollMove: any = {};
  public previewData: any[] = [];
  public imgType = ["jpg", "png", "jpeg", "tiff"];
  public showPreviewPopup = false;
  public getCertificatesFilesPathUrl = "";
  public errorMessage = "";
  public userTaskAllStatus: string[] = [];
  public isEmpResend = false;
  public isReferenceResend = false;
  public updateReviewer: any = null;
  public editIndex: any = 0;

  public async created() {
    this.getCertificatesFilesPathUrl =
      appConfigService.getS3CertificatesFilesPathUrl();
    this.envType = appConfigService.getEnvironmentType();
    this.formType = this.$route.query.formType?.toString();
    this.userDetails = utils.getUserDetails();
    if (utils.checkIsMobileView() || utils.checkIsTabView()) {
      this.isMobileView = true;
    } else {
      this.isMobileView = false;
    }
    this.certificateApplicationId = this.$route.path.split("/")[3];
    if (this.$route.path.split("/")[1] === "reviewer-dashboard") {
      this.isUserApplication = false;
      this.applicationsTabChange(
        this.applicationsTabSelect,
        "application",
        true
      );
      await this.getCertificationApplicationData();
    } else {
      this.isUserApplication = true;
      await this.getUserApplicationData();
      this.applicationsTabChange(
        this.applicationsTabSelect,
        "application",
        true
      );
    }
    if (this.$route.path.split("/")[2] === "my-application") {
      this.statusChange();
    }
  }

  public onCertificationSubmit() {
    this.checkCertificateValid = true;
    this.$validator.validate().then((validate) => {
      if (validate) {
        this.checkCertificateValid = false;
        // Only a freshly picked File is worth sending. Once a certificate has
        // been uploaded, certificateFile holds the saved file's metadata, and
        // that object is not a file part - it would reach the API as a string.
        // Leaving it out is how the API is told to keep the stored file, which
        // is what an untouched picker means.
        const pickedFiles = this.certification.certificateFile.filter(
          (file: any) => file instanceof File
        );
        const typedNumber = this.certification.certificateNumber || "";
        const savedNumber = this.certificatePreviewForm.certificateNumber || "";
        const isNumberChanged = typedNumber !== savedNumber;
        if (!isNumberChanged && !pickedFiles.length) {
          // Nothing was touched, so the edit closes the way Cancel does rather
          // than sending a request the API answers with "Invalid data".
          this.isEditCertificate = false;
          return;
        }
        const certificatePayload: certificationDetails = {
          applicationId: this.certificateApplicationId,
          file: pickedFiles,
        };
        // The number goes out only when it changed. It used to be stripped
        // whenever one existed, which dropped edits; sending it every time
        // instead puts an unchanged number back through the API's already-taken
        // check, and a build older than the one that excludes the application's
        // own row rejects it.
        if (isNumberChanged) {
          certificatePayload.certificateNumber = typedNumber;
        }
        // Saving deliberately does not raise isLoading: that unmounts the whole
        // page, and a number the API refuses has to come back to the form the
        // reviewer typed it into, with their number and any picked file still
        // in front of them to correct and send again.
        this.isCertificateSaving = true;
        certificationFormApi
          .certificationUpdate(certificatePayload)
          .then(() => {
            this.isCertificateSaving = false;
            this.isEditCertificate = false;
            this.getCertificationApplicationData();
          })
          .catch((error) => {
            this.isCertificateSaving = false;
            this.errorMessage = utils.errorMessage(error);
          });
      }
    });
  }

  public editCertificate() {
    this.isEditCertificate = true;
  }

  public cancelCertificateEdit() {
    this.isEditCertificate = false;
    this.checkCertificateValid = false;
    this.getCertificationApplicationData();
  }

  public getUserApplicationData() {
    this.certificatePreviewForm = this.applicationPreviewForm;
    this.certificatePreviewForm.certifiedAt = this.certificatePreviewForm
      .certifiedAt
      ? moment(this.certificatePreviewForm.certifiedAt).format("MM-DD-YYYY")
      : "--";
    this.certificatePreviewForm.expiryDate = this.certificatePreviewForm
      .expiryDate
      ? moment(this.certificatePreviewForm.expiryDate).format("MM-DD-YYYY")
      : "--";
    if (this.applicationPreviewForm.submittedMode === "migration") {
      this.isMigrationForm = true;
    }
    this.applicationReceivedDate = moment(
      this.certificatePreviewForm.data.certificationPartTwoSignature
        .submissionDate
    ).format("MM-DD-YYYY");
    this.applicantFullName = `${this.certificatePreviewForm.data.certificationPartTwoApplicationForm.firstName} ${this.certificatePreviewForm.data.certificationPartTwoApplicationForm.lastName}`;
    this.certificatePreviewForm.data.certificationPartTwoApplicationForm.fullName =
      this.applicantFullName;
    const fullAddress = utils.addressBuilder(
      this.certificatePreviewForm.data,
      "certificationPartTwoApplicationForm",
      "default"
    );
    this.certificatePreviewForm.data.certificationPartTwoApplicationForm.fullAddress =
      fullAddress;
    if (
      this.certificatePreviewForm.data.certificationPartTwoSupervisorInformation
        ?.length
    ) {
      for (
        let idx = 0;
        idx <
        this.certificatePreviewForm.data
          .certificationPartTwoSupervisorInformation.length;
        idx++
      ) {
        this.certificatePreviewForm.data.certificationPartTwoSupervisorInformation[
          idx
        ].supervisorFullName = `${this.certificatePreviewForm.data.certificationPartTwoSupervisorInformation[idx].supervisorFirstName} ${this.certificatePreviewForm.data.certificationPartTwoSupervisorInformation[idx].supervisorLastName}`;
        const supervisorFullAddress = utils.addressBuilder(
          this.certificatePreviewForm.data,
          "certificationPartTwoSupervisorInformation",
          "supervisor",
          true,
          idx
        );
        this.certificatePreviewForm.data.certificationPartTwoSupervisorInformation[
          idx
        ].supervisorFullAddress = supervisorFullAddress;
      }
    }
    this.isLoading = false;
    const previewClass = document.querySelector("part-two-preview-container");
    if (previewClass) {
      (previewClass as HTMLElement)?.focus();
    }
    setTimeout(() => {
      this.getHeaderHeight();
    }, 1000);
  }

  public isEditForm(event: any) {
    this.isEditReviewer = event;
  }
  public isUpdateForm(event: any) {
    this.updateReviewer = event;
    this.$nextTick(() => {
      this.$bvModal.show("update-email-center");
    });
  }
  public getUpdatedData(event: boolean) {
    if (event) {
      this.collapseIdx = "";
      this.getCertificationApplicationData();
    }
  }
  public getPeerUpdatedData(event: boolean) {
    this.$emit("getPeerUpdatedData", true);
    if (event) {
      this.collapseIdx = "";
      this.$emit("isUpdateForm", event);
      this.statusChange();
    }
  }
  public statusChange() {
    if (
      this.certificatePreviewForm.data
        .certificationPartTwoRefererenceInformation?.length
    ) {
      this.certificatePreviewForm.data.certificationPartTwoRefererenceInformation.forEach(
        (item: any) => {
          const checkStatus = this.certificatePreviewForm.referral.find(
            (ref: any) => {
              return ref.email === item.referenceEmailAddress;
            }
          );
          item.status = checkStatus?.status;
        }
      );
    }
    if (
      this.certificatePreviewForm.data.certificationPartTwoSupervisorInformation
        ?.length
    ) {
      for (
        let idx = 0;
        idx <
        this.certificatePreviewForm.data
          .certificationPartTwoSupervisorInformation.length;
        idx++
      ) {
        const checkStatus = this.certificatePreviewForm.employeeSummary.find(
          (ref: any) => {
            return (
              ref.email ===
              this.certificatePreviewForm.data
                .certificationPartTwoSupervisorInformation[idx].supervisorEmail
            );
          }
        );
        this.certificatePreviewForm.data.certificationPartTwoSupervisorInformation[
          idx
        ].status = checkStatus?.status;
      }
    }
  }

  public getEditIndex(event: any) {
    if (event) {
      this.editIndex = event;
    }
  }
  public getCertificationApplicationData() {
    this.totalRejectedReferenceCount = 0;
    this.totalRejectedSupervisorCount = 0;
    this.editedUserDetails = [];
    this.isLoading = true;
    let getAllEditedData: any[] = [];
    let temp: any;
    certificationFormApi
      .getCertificationApplicationForm(this.certificateApplicationId)
      .then((result) => {
        const userId = this.userDetails.userId;
        const userTask = result.data.userTask;
        this.historys = userTask.sort((a: any, b: any) => {
          a.createdAt = moment(a.createdAt).format("MM-DD-YYYY HH:mm:ss:SSS");
          b.createdAt = moment(b.createdAt).format("MM-DD-YYYY HH:mm:ss:SSS");
          return (
            new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
          );
        });

        //Store all userTask status

        this.userTaskAllStatus = userTask.map((task: any) => {
          return task.status;
        });

        // current userTask and findStatus
        const currentUserTask = userTask.filter(
          (task: any) => task.userId === userId
        );
        const mostRecentHistory = currentUserTask.sort((a: any, b: any) => {
          return moment(a.createdAt, "MM-DD-YYYY HH:mm:ss").diff(
            moment(b.createdAt, "MM-DD-YYYY HH:mm:ss")
          );
        });
        this.mostLastRecord = mostRecentHistory[mostRecentHistory.length - 1];
        result.data.createdAt = moment(result.data.createdAt).format(
          "MM-DD-YYYY"
        );
        this.historys.map((data: any) => {
          data.createdAt = moment
            .utc(data.createdAt)
            .local()
            .format("MM-DD-YYYY HH:mm A");
        });
        this.historys.reverse();
        this.activeReferral = [result.data.referral[0]];
        this.activeSupervisor = [result.data.employeeSummary[0]];
        result.data.createdAt = moment(result.data.createdAt).format(
          "MM-DD-YYYY"
        );
        this.applicationReceivedDate = moment(
          result.data.data.certificationPartTwoSignature.submissionDate
        ).format("MM-DD-YYYY");
        if (result.data.certifiedAt) {
          result.data.certifiedAt = moment(result.data.certifiedAt).format(
            "MM-DD-YYYY"
          );
        }
        if (result.data.expiryDate) {
          result.data.expiryDate = moment(result.data.expiryDate).format(
            "MM-DD-YYYY"
          );
        }
        this.certificatePreviewForm = result.data;
        if (this.certificatePreviewForm.submittedMode === "migration") {
          this.isMigrationForm = true;
        }
        if (
          this.certificatePreviewForm.referral.length > 2 &&
          this.certificatePreviewForm.referralStatus !== null &&
          this.certificatePreviewForm.summaryStatus !== null
        ) {
          this.isAllApplicationSubmitted = true;
        } else {
          this.isAllApplicationSubmitted = false;
        }
        this.applicantFullName = `${this.certificatePreviewForm.data.certificationPartTwoApplicationForm.firstName} ${this.certificatePreviewForm.data.certificationPartTwoApplicationForm.lastName}`;
        this.certificatePreviewForm.data.certificationPartTwoApplicationForm.fullName =
          this.applicantFullName;
        const fullAddress = utils.addressBuilder(
          this.certificatePreviewForm.data,
          "certificationPartTwoApplicationForm",
          "default"
        );
        this.certificatePreviewForm.data.certificationPartTwoApplicationForm.fullAddress =
          fullAddress;
        if (
          this.certificatePreviewForm.data
            .certificationPartTwoRefererenceInformation?.length
        ) {
          this.certificatePreviewForm.data.certificationPartTwoRefererenceInformation.forEach(
            (item: any) => {
              const checkStatus = this.certificatePreviewForm.referral.find(
                (ref: any) => {
                  return ref.email === item.referenceEmailAddress;
                }
              );
              item.status = checkStatus?.status;
            }
          );
        }
        if (
          this.certificatePreviewForm.data
            .certificationPartTwoSupervisorInformation?.length
        ) {
          for (
            let idx = 0;
            idx <
            this.certificatePreviewForm.data
              .certificationPartTwoSupervisorInformation.length;
            idx++
          ) {
            this.certificatePreviewForm.data.certificationPartTwoSupervisorInformation[
              idx
            ].supervisorFullName = `${this.certificatePreviewForm.data.certificationPartTwoSupervisorInformation[idx].supervisorFirstName} ${this.certificatePreviewForm.data.certificationPartTwoSupervisorInformation[idx].supervisorLastName}`;
            const supervisorFullAddress = utils.addressBuilder(
              this.certificatePreviewForm.data,
              "certificationPartTwoSupervisorInformation",
              "supervisor",
              true,
              idx
            );
            this.certificatePreviewForm.data.certificationPartTwoSupervisorInformation[
              idx
            ].supervisorFullAddress = supervisorFullAddress;
            const checkStatus =
              this.certificatePreviewForm.employeeSummary.find((ref: any) => {
                return (
                  ref.email ===
                  this.certificatePreviewForm.data
                    .certificationPartTwoSupervisorInformation[idx]
                    .supervisorEmail
                );
              });
            this.certificatePreviewForm.data.certificationPartTwoSupervisorInformation[
              idx
            ].status = checkStatus?.status;
          }
        }
        if (
          this.certificatePreviewForm.progressStatus === STATUS.accepted ||
          this.certificatePreviewForm.progressStatus === STATUS.notAccepted ||
          this.certificatePreviewForm.progressStatus === STATUS.needMoreInfo
        ) {
          const mostRecentHistory = this.certificatePreviewForm.userTask.sort(
            (a, b) =>
              new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
          )[0];
          if (
            mostRecentHistory.userId === this.userDetails.userId &&
            mostRecentHistory.status === STATUS.completed
          ) {
            this.commentEventNone = true;
            this.approveComment = this.certificatePreviewForm.comment;
            this.approveStatus = this.certificatePreviewForm.progressStatus;
          }
        }
        this.certification.certificateNumber =
          this.certificatePreviewForm.certificateNumber;
        this.certification.certificateFile = this.certificatePreviewForm
          .certificateFile
          ? [this.certificatePreviewForm.certificateFile]
          : [];
        if (this.formsSelect === "letter-references") {
          this.refrenceClickable(
            this.certificatePreviewForm.data
              .certificationPartTwoRefererenceInformation[
              this.refereshReferenceAndSupervisor
                ? this.refereshReferenceAndSupervisor.idx
                : 0
            ].referenceEmailAddress,
            this.refereshReferenceAndSupervisor
              ? this.refereshReferenceAndSupervisor.idx
              : 0
          );
        }
        if (this.formsSelect === "employment-summary") {
          this.supervisorClickable(
            this.certificatePreviewForm.data
              .certificationPartTwoSupervisorInformation[
              this.refereshReferenceAndSupervisor
                ? this.refereshReferenceAndSupervisor.idx
                : 0
            ].supervisorEmail,
            this.refereshReferenceAndSupervisor
              ? this.refereshReferenceAndSupervisor.idx
              : 0
          );
        }

        //reference rejection count

        this.certificatePreviewForm.referral.find((reference: any) => {
          if (reference.status === STATUS.notAccepted) {
            this.totalRejectedReferenceCount++;
            if (reference.notificationStatus === "NOTIFICATION_PENDING") {
              const referenceDetail = {
                name:
                  reference.data.letterOfReferenceReferenceDetails
                    .referenceFirstName +
                  " " +
                  reference.data.letterOfReferenceReferenceDetails
                    .referenceLastName,
                email: reference.email,
              };
              if (this.newlyRejectedReference.length) {
                const idx = this.newlyRejectedReference.findIndex(
                  (element) => element.email === referenceDetail.email
                );
                if (idx < 0) {
                  this.newlyRejectedReference.push(referenceDetail);
                }
              } else {
                this.newlyRejectedReference = [referenceDetail];
              }
            }
          }
        });

        //supervisor rejection count

        this.certificatePreviewForm.employeeSummary.find((supervisor: any) => {
          if (supervisor.status === STATUS.notAccepted) {
            this.totalRejectedSupervisorCount++;
            if (supervisor.notificationStatus === "NOTIFICATION_PENDING") {
              const supervisorDetail = {
                name:
                  supervisor.data.supervisorContactInformation.firstName +
                  " " +
                  supervisor.data.supervisorContactInformation.lastName,
                email: supervisor.email,
              };
              if (this.newlyRejectedSupervisor.length) {
                const idx = this.newlyRejectedSupervisor.findIndex(
                  (element) => element.email === supervisorDetail.email
                );
                if (idx < 0) {
                  this.newlyRejectedSupervisor.push(supervisorDetail);
                }
              } else {
                this.newlyRejectedSupervisor = [supervisorDetail];
              }
            }
          }
        });

        this.statusCheck();
        setTimeout(() => {
          this.isLoading = false;
          this.getHeaderHeight();
        }, 1000);
        this.isLoading = false;
        for (const property in this.certificatePreviewForm.data) {
          if (Array.isArray(this.certificatePreviewForm.data["History"])) {
            this.certificatePreviewForm.data["History"].map(
              (historyData: any) => {
                let certificatePreviewData;
                if (
                  property === "certificationPartTwoRefererenceInformation" ||
                  property === "certificationPartTwoSupervisorInformation"
                ) {
                  certificatePreviewData =
                    this.certificatePreviewForm.data[property][this.editIndex];
                } else {
                  certificatePreviewData =
                    this.certificatePreviewForm.data[property];
                }
                for (const innerProperty in certificatePreviewData) {
                  if (innerProperty === "handbook") {
                    for (const SOAproperty in this.certificatePreviewForm.data[
                      property
                    ][innerProperty]) {
                      for (const SOAinnerProperty in this.certificatePreviewForm
                        .data[property][innerProperty][SOAproperty]) {
                        if (
                          historyData[SOAinnerProperty] &&
                          historyData[SOAinnerProperty].length
                        ) {
                          temp = JSON.parse(
                            JSON.stringify(historyData[SOAinnerProperty])
                          );
                          temp.forEach((element: any) => {
                            if (this.filesEdit.includes(SOAinnerProperty)) {
                              element.oldValue = element.oldValue.map(
                                (data: any) => {
                                  return data.originalFileName;
                                }
                              );
                              element.newValue = element.newValue.map(
                                (data: any) => {
                                  return data.originalFileName;
                                }
                              );
                            }
                            if (
                              typeof element.oldValue === "object" &&
                              typeof element.newValue === "object"
                            ) {
                              element.oldValue = element.oldValue.length
                                ? element.oldValue.join(", ")
                                : element.oldValue;
                              element.newValue = element.newValue.length
                                ? element.newValue.join(", ")
                                : element.newValue;
                            }
                            temp = element;
                            switch (property) {
                              case "certificationPartTwoHandbook":
                                temp.mainLabel = "Code of Ethics";
                                break;
                              default:
                                break;
                            }
                            if (getAllEditedData.length) {
                              getAllEditedData.push(temp);
                            } else {
                              getAllEditedData = [temp];
                            }
                          });
                        }
                      }
                    }
                  } else {
                    if (
                      historyData[innerProperty] &&
                      historyData[innerProperty].length
                    ) {
                      temp = JSON.parse(
                        JSON.stringify(historyData[innerProperty])
                      );
                      temp?.forEach((element: any) => {
                        if (
                          this.filesEdit.length &&
                          this.filesEdit.includes(innerProperty)
                        ) {
                          element.oldValue = element.oldValue.map(
                            (data: any) => {
                              return data.originalFileName;
                            }
                          );
                          element.newValue = element.newValue.map(
                            (data: any) => {
                              return data.originalFileName;
                            }
                          );
                        }
                        if (
                          typeof element.oldValue === "object" &&
                          typeof element.newValue === "object"
                        ) {
                          element.oldValue = element.oldValue.length
                            ? element.oldValue.join(", ")
                            : element.oldValue;
                          element.newValue = element.newValue.length
                            ? element.newValue.join(", ")
                            : element.newValue;
                        }
                        temp = element;
                        switch (property) {
                          case "certificationPartTwoApplicationForm":
                            temp.mainLabel = "Basic Details";
                            break;
                          case "certificationPartTwoRefererenceInformation":
                            temp.mainLabel = "Reference Details";
                            break;
                          case "certificationPartTwoSupervisorInformation":
                            temp.mainLabel = "Supervisor Details";
                            break;
                          default:
                            break;
                        }
                        if (getAllEditedData.length) {
                          getAllEditedData.push(temp);
                        } else {
                          getAllEditedData = [temp];
                        }
                      });
                    }
                  }
                }
              }
            );
          }
        }
        getAllEditedData = getAllEditedData.filter(
          (currentValue, currentIndex) => {
            if (
              (currentValue.mainLabel === "Basic Details" &&
                currentValue.parentName ===
                  "certificationPartTwoApplicationForm") ||
              (currentValue.mainLabel === "Reference Details" &&
                currentValue.parentName ===
                  "certificationPartTwoRefererenceInformation") ||
              (currentValue.mainLabel === "Supervisor Details" &&
                currentValue.parentName ===
                  "certificationPartTwoSupervisorInformation")
            ) {
              return currentValue;
            }
          }
        );
        const unique = [
          ...new Set(
            getAllEditedData.map((a) => {
              return a.editDataTime + "/" + a.editorDetails.userId;
            })
          ),
        ];
        unique.forEach((splitUnique: string) => {
          const dateTime = splitUnique.split("/")[0];
          const userId = splitUnique.split("/")[1];
          getAllEditedData.forEach((data: editChangesData) => {
            if (
              data.editDataTime === dateTime &&
              data.editorDetails.userId === userId
            ) {
              if (this.editedUserDetails.length) {
                const editedIdx = this.editedUserDetails.findIndex(
                  (editDetail) => {
                    return (
                      editDetail.editorUserId === data.editorDetails.userId &&
                      editDetail.dateTime === data.editDataTime
                    );
                  }
                );
                if (editedIdx > -1) {
                  this.editedUserDetails[editedIdx].changesCount =
                    this.editedUserDetails[editedIdx].changesCount + 1;
                  if (this.editedUserDetails[editedIdx].data.length) {
                    const idx = this.editedUserDetails[
                      editedIdx
                    ].data.findIndex((a: any) => {
                      return a.mainLabel === data.mainLabel;
                    });
                    if (idx > -1) {
                      this.editedUserDetails[editedIdx].data[
                        idx
                      ].changesData?.push(data);
                    } else {
                      this.editedUserDetails[editedIdx].data.push({
                        mainLabel: data.mainLabel,
                        changesData: [data],
                      });
                    }
                  }
                } else {
                  this.editedUserDetails.push({
                    editorUserId: data.editorDetails.userId,
                    data: [
                      {
                        mainLabel: data.mainLabel,
                        changesData: [data],
                      },
                    ],
                    dateTime: data.editDataTime,
                    editorName: data.editorDetails.name,
                    changesCount: 1,
                    comment: this.getComment(
                      this.certificatePreviewForm.data,
                      data.editDataTime,
                      data.editorDetails.userId
                    ),
                  });
                }
              } else {
                this.editedUserDetails = [
                  {
                    editorUserId: data.editorDetails.userId,
                    data: [
                      {
                        mainLabel: data.mainLabel,
                        changesData: [data],
                      },
                    ],
                    dateTime: data.editDataTime,
                    editorName: data.editorDetails.name,
                    changesCount: 1,
                    comment: this.getComment(
                      this.certificatePreviewForm.data,
                      data.editDataTime,
                      data.editorDetails.userId
                    ),
                  },
                ];
              }
            }
          });
        });
        this.editedUserDetails = this.editedUserDetails.sort(
          (a: any, b: any) => {
            a.dateTime = moment(a.dateTime).format("MM-DD-YYYY HH:mm:ss:SSS");
            b.dateTime = moment(b.dateTime).format("MM-DD-YYYY HH:mm:ss:SSS");
            return (
              new Date(a.dateTime).getTime() - new Date(b.dateTime).getTime()
            );
          }
        );
        this.editedUserDetails.map((data: any) => {
          data.dateTime = moment(data.dateTime).format(
            "MM-DD-YYYY [|] HH:mm A"
          );
        });
        this.editedUserDetails.reverse();
      })
      .catch((error) => {
        this.errorMessage = utils.errorMessage(error);
        this.isLoading = false;
      });
  }

  public getComment(data: any, dateTime: string, editorId: string) {
    let comment = "";
    for (const property in data) {
      if (property === "editedComments") {
        data[property].filter((data: any) => {
          if (
            data.dateTime === dateTime &&
            data.editorDetails.userId === editorId
          ) {
            comment = data.comment;
          }
        });
      }
    }
    return comment;
  }
  // for mobile preview

  public tabChange(tabSelect: string, formName = "") {
    this.isFormValid = !this.isFormValid;
    setTimeout(() => {
      if (this.tabSelected !== tabSelect && this.validForm) {
        this.tabSelected = tabSelect;
        if (this.formType === "offline") {
          this.isUpdatePageNumber = true;
          switch (formName) {
            case "application":
              this.source =
                "https://dno579h3gzw0n.cloudfront.net/files_upload/41896fbe-72fc-425a-8548-49ce8eab68c6.pdf";
              break;
            case "employment":
              this.source =
                "https://dno579h3gzw0n.cloudfront.net/files_upload/ad881f86-c6a7-40e8-9943-e705c8f08a42.pdf";
              break;
            default:
              break;
          }
        }
        this.getHeaderHeight();
      }
    }, 50);
  }

  public refrenceClickable(refrenceEmail: any, idx: number) {
    this.referenceIndex = idx;
    this.activeReferral = this.certificatePreviewForm.referral.filter(
      (filter) => {
        if (filter.email === refrenceEmail) {
          return filter;
        }
      }
    );
    if (this.activeReferral[0].data) {
      this.isReferenceData = true;
    } else {
      this.isReferenceData = false;
    }
  }

  public supervisorClickable(supervisorEmail: any, idx: number) {
    this.supervisorIndex = idx;
    this.activeSupervisor = this.certificatePreviewForm.employeeSummary.filter(
      (filter: any) => {
        if (filter.email === supervisorEmail) {
          return filter;
        }
      }
    );
    if (this.activeSupervisor[0].data) {
      this.isSupervisorData = true;
    } else {
      this.isSupervisorData = false;
    }
  }

  public isValidForm(event: any) {
    this.validForm = event;
  }

  public applicationsTabChange(
    tabSelect: string,
    formName = "",
    initialLoad = false
  ) {
    this.isFormValid = !this.isFormValid;
    setTimeout(() => {
      if (this.applicationsTabSelect !== tabSelect && this.validForm) {
        this.applicationsTabSelect = tabSelect;
        if (this.formType === "offline") {
          this.isUpdatePageNumber = true;
          switch (formName) {
            case "application":
              this.source =
                "https://dno579h3gzw0n.cloudfront.net/files_upload/41896fbe-72fc-425a-8548-49ce8eab68c6.pdf";
              break;
            case "employment":
              this.source =
                "https://dno579h3gzw0n.cloudfront.net/files_upload/ad881f86-c6a7-40e8-9943-e705c8f08a42.pdf";
              break;
            default:
              break;
          }
        }
        if (!initialLoad) {
          this.getHeaderHeight();
        }
      }
    }, 50);
  }

  public formsTabChange(tabSelect: string, formName = "") {
    this.isFormValid = !this.isFormValid;
    this.tabScrollMove = {};
    setTimeout(() => {
      if (!this.isEditReviewer && this.validForm) {
        switch (formName) {
          case "application":
            this.applicationsTabChange("partTwo-basic-details", "application");
            break;
          case "employment":
            this.supervisorClickable(
              this.certificatePreviewForm.data
                .certificationPartTwoSupervisorInformation[0].supervisorEmail,
              0
            );
            break;
          case "reference":
            this.refrenceClickable(
              this.certificatePreviewForm.data
                .certificationPartTwoRefererenceInformation[0]
                .referenceEmailAddress,
              0
            );
            break;
          default:
            break;
        }
        this.formsSelect = tabSelect;
        setTimeout(() => {
          this.getHeaderHeight();
        }, 50);
      }
    });
  }

  public getHeaderHeight() {
    const getHeaderElement = document.querySelector(".header");
    const getSectionTabElement = document.querySelector(".form-tab");
    this.headerHeight = getHeaderElement?.clientHeight as number;
    if (this.isMobileView) {
      const getMainHeaderElementHeight = document.querySelector(
        ".mobile-nav-container"
      )?.clientHeight as number;
      this.headerHeight = this.headerHeight + getMainHeaderElementHeight;
      const getMobileElement = document.querySelector(".mobile-section-tab");
      this.mobileSectionTabHeight = getMobileElement?.clientHeight as number;
    }
    this.sectionTabHeight = getSectionTabElement?.clientHeight as number;
    if (this.formsSelect === "employment-summary") {
      const getSummaryTabHeight = document.querySelector(
        ".supervisor-count-tab"
      )?.clientHeight as number;
      this.headerHeight = this.headerHeight + getSummaryTabHeight;
    }
    if (this.formsSelect === "letter-references") {
      const getReferenceTabHeight = document.querySelector(
        ".reference-count-tab"
      )?.clientHeight as number;
      this.headerHeight = this.headerHeight + getReferenceTabHeight;
    }
  }

  public statusUpdate(status: string) {
    this.approveStatus = status;
    this.toogleStatus = !this.toogleStatus;
  }

  public emitStatusAndComment(emitedData: any) {
    if (emitedData.status) {
      this.isLoading = true;
      this.isApproveStatus = true;
      const data = {
        id: this.certificateApplicationId,
        status: emitedData.status.toLocaleUpperCase(),
        comment: emitedData.comment,
        rubric: emitedData.rubric ? emitedData.rubric : "",
      };
      commonService
        .approveApplication(data, "certification")
        .then(() => {
          this.getCertificationApplicationData();
        })
        .catch((error) => {
          this.errorMessage = utils.errorMessage(error);
          this.isLoading = false;
        });
    }
  }
  public referencePageReferesh(event: any) {
    if (event) {
      if (this.formsSelect === "letter-references") {
        this.refereshReference = event;
      }
      this.getCertificationApplicationData();
    }
  }

  public SupervisorPageReferesh(event: any) {
    if (event) {
      if (this.formsSelect === "employment-summary") {
        this.refereshSupervisor = event;
      }
      this.getCertificationApplicationData();
    }
  }

  public referenceAndSupervisorPageReferesh(event: any) {
    if (event) {
      this.refereshReferenceAndSupervisor = event;
      this.getCertificationApplicationData();
    }
  }

  public statusCheck() {
    const status = utils.scoringSectionHideShow(
      this.certificatePreviewForm.progressStatus,
      this.mostLastRecord.status,
      "certification",
      this.userTaskAllStatus
    );
    this.showRubricTab = status["showRubricTab"];
    this.showCertification = status["showCertification"];
  }

  public getApplicantId() {
    this.isUpdatePageNumber = false;
    if (this.formsSelect === "application-form") {
      this.PDFApplicationPrintName = `Part-two-application-${this.certificatePreviewForm.code}`;
    } else if (this.formsSelect === "employment-summary") {
      this.PDFApplicationPrintName = `Employment-summary-application-${this.certificatePreviewForm.code}`;
    } else if (this.formsSelect === "letter-references") {
      this.PDFApplicationPrintName = `Letter-of-references-application-${this.certificatePreviewForm.code}`;
    }
  }

  public informApplicant(form: string) {
    this.isLoading = true;
    if (form === "reference") {
      const rejectedEmails = this.newlyRejectedReference.map(
        (data) => data.email
      );
      certificationFormApi
        .informRejectedReference(rejectedEmails, this.certificatePreviewForm.id)
        .then(() => {
          this.isInformedApplicant = true;
          this.newlyRejectedReference = [];
          this.getCertificationApplicationData();
          this.$bvModal.hide("rejected-msg-sent-model");
        })
        .catch((error) => {
          this.errorMessage = utils.errorMessage(error);
          this.isLoading = false;
        });
    } else {
      const rejectedEmails = this.newlyRejectedSupervisor.map(
        (data) => data.email
      );
      certificationFormApi
        .informRejectedSupervisor(
          rejectedEmails,
          this.certificatePreviewForm.id
        )
        .then(() => {
          this.isInformedApplicant = true;
          this.newlyRejectedSupervisor = [];
          this.getCertificationApplicationData();
          this.$bvModal.hide("rejected-msg-sent-model");
        })
        .catch((error) => {
          this.errorMessage = utils.errorMessage(error);
          this.isLoading = false;
        });
    }
  }

  public cancelInform() {
    this.$bvModal.hide("rejected-msg-sent-model");
    this.isInformedApplicant = false;
  }

  public rightMoveTab() {
    const conent = document.getElementsByClassName("ref-lists")[0];
    if (conent) {
      this.tabScrollMove = utils.rightMoveTab(conent, 300);
    }
  }
  public leftMoveTab() {
    const conent = document.getElementsByClassName("ref-lists")[0];
    if (conent) {
      this.tabScrollMove = utils.leftMoveTab(conent, 300);
    }
  }

  public async previewCertificate(file: any) {
    if (this.imgType.includes(file.uploadedFileName.split(".")[1])) {
      const img = new Image();
      img.src = `${this.getCertificatesFilesPathUrl}/${file.uploadedFileName}`;
      file.width = img.width;
      file.height = img.height;
    }
    this.previewData = [file];
    this.showPreviewPopup = true;
  }

  public hidePreviewPopup(event: boolean) {
    if (event === true) {
      this.showPreviewPopup = false;
      this.previewData = [];
    }
  }

  public namesJoin(data: any[], joinKey: string) {
    return utils.joinArrObj(data, joinKey);
  }

  public closdedErrorPopup(event: any) {
    if (event) {
      this.errorMessage = "";
    }
  }

  public disableCommentandScoringSection(
    currentUserStatus: string,
    progressStatus: string,
    section: string
  ) {
    return utils.disableCommentandScoringSection(
      currentUserStatus,
      progressStatus,
      section
    );
  }
  public backUrl() {
    if (this.$route.query.isReport) {
      let filter = "";
      if (this.$route.query.ethnicity) {
        filter += `&ethnicity=${this.$route.query.ethnicity}`;
      }
      if (this.$route.query.gender) {
        filter += `&gender=${this.$route.query.gender}`;
      }
      if (this.$route.query.region) {
        filter += `&region=${this.$route.query.region}&regionId=${this.$route.query.regionId}`;
      }
      if (this.$route.query.age) {
        filter += `&age=${this.$route.query.age}&fromAge=${this.$route.query.fromAge}&toAge=${this.$route.query.toAge}`;
      }
      if (this.$route.query.education) {
        filter += `&education=${this.$route.query.education}`;
      }
      // Report question filters, so the peers preview (and the list behind
      // it) comes back with the same filter applied.
      [
        "servedMilitary",
        "mentalRecovery",
        "substanceRecovery",
        "coOccurring",
        "employmentStatus",
      ].forEach((key: string) => {
        const answer = this.$route.query[key];
        if (answer) {
          filter += `&${key}=${answer}`;
        }
      });
      return `/reviewer-dashboard/peers-preview?id=${this.$route.query.id}&type=${this.$route.query.type}&isReport=${this.$route.query.isReport}&fromDate=${this.$route.query.fromDate}&toDate=${this.$route.query.toDate}${filter}`;
    } else {
      return this.isPeerPreview
        ? `/reviewer-dashboard/peers-preview?id=${this.$route.query.id}`
        : "/reviewer-dashboard/part-two";
    }
  }
  public onResend(activeUser: any, isEmp: any) {
    this.isLoading = true;
    const payload = {
      email: activeUser.email,
      id: activeUser.applicationId,
    };

    if (isEmp) {
      certificationFormApi
        .employeeResendEmail(payload)
        .then(() => {
          this.isLoading = false;
          this.isEmpResend = true;
          this.isReferenceResend = false;
          this.$nextTick(() => {
            this.$bvModal.show("resend-email-center");
          });
        })
        .catch((error) => {
          this.isLoading = false;
        });
    } else {
      certificationFormApi
        .referenceEmail(payload)
        .then(() => {
          this.isLoading = false;
          this.isReferenceResend = true;
          this.isEmpResend = false;
          this.$nextTick(() => {
            this.$bvModal.show("resend-email-center");
          });
        })
        .catch((error) => {
          this.isLoading = false;
        });
    }
  }
  public closePopup() {
    this.$bvModal.hide("update-email-center");
  }

  public showDelete = appConfigService.getShowDelete();
  public deleteTargetId = "";
  public deleteFirstName = "";
  public deleteLastName = "";
  public deleteSubmittedAt = "";
  public deleteEmail = "";
  public deleteProgressStatus = "";
  public deleteSuccess = false;

  public confirmDelete() {
    this.deleteTargetId = this.certificatePreviewForm.id;
    this.deleteFirstName = this.certificatePreviewForm.firstName;
    this.deleteLastName = this.certificatePreviewForm.lastName;
    this.deleteSubmittedAt = this.certificatePreviewForm.submittedAt;
    this.deleteEmail = this.certificatePreviewForm.email;
    this.deleteProgressStatus = this.certificatePreviewForm.progressStatus;
    this.deleteSuccess = false;
    this.$bvModal.show("delete-application-modal-part-two-preview");
  }

  public cancelDelete() {
    this.deleteSuccess = false;
    this.$bvModal.hide("delete-application-modal-part-two-preview");
  }

  public submitDelete() {
    this.isLoading = true;
    certificationFormApi
      .deleteCertificateApplication(this.deleteTargetId)
      .then(() => {
        this.isLoading = false;
        this.deleteSuccess = true;
        setTimeout(() => {
          this.$bvModal.hide("delete-application-modal-part-two-preview");
          this.deleteSuccess = false;
          // backUrl() is where Back goes: the peer's profile when the form was
          // opened from Peers (and the Reports list, filters intact, when it
          // came from there), the application's own table otherwise. Deleting
          // used to ignore that and always land on the table, so a reviewer
          // clearing an application off a peer's profile was dropped into a
          // list they had not come from.
          this.$router.push(this.backUrl());
        }, 2000);
      })
      .catch((error) => {
        this.errorMessage = utils.errorMessage(error);
        this.isLoading = false;
      });
  }
}
